import toastr from 'react-hot-toast'
import { useMutation, useQueryClient } from 'react-query'
import { fetchWrapper } from 'utils/fetchWrapper'
import type {
  FavouriteListAttribute,
  SingleFavouriteListResponse,
} from 'types/FavouriteList'

type mutationVariables = FavouriteListAttribute['name']

export function useCreateFavouriteList() {
  const queryClient = useQueryClient()

  const createFavoriteList = (listName: mutationVariables) => {
    if (!listName) {
      Promise.reject('listName can not be null')
    }

    const body = {
      data: {
        type: 'favouriteLists',
        attributes: {
          name: listName,
        },
      },
    }

    return fetchWrapper<SingleFavouriteListResponse>({
      url: `FavouriteLists`,
      method: 'Post',
      body: body,
    })
  }

  return useMutation('createFavoriteList', createFavoriteList, {
    onSuccess: () => {
      queryClient.invalidateQueries(['sparks'])
      queryClient.invalidateQueries(['sparkFavourites'])
      queryClient.invalidateQueries(['favouriteLists'])
    },
    onError: (error) => {
      if (error instanceof Error) {
        toastr.error(`failed to create favourite list: ${error.message}`)
      }
    },
  })
}
